<p-toast
  position="top-center"
  key="ps-toast"
  [class]="'ps-toast'"
  [attr.data-cy]="'ps-toast'"
  [baseZIndex]="5000"
>
  <ng-template #headless let-message let-closeFn="closeFn">
    <ps-alert
      class="enter-animation w-100"
      [attr.data-cy]="`ps-toast-${message.severity}`"
      [variant]="message.severity"
      [dismissible]="message.closable"
      (dismissed)="closeFn()"
    >
      <span class="px-2">
        {{ message.summary }}
      </span>
    </ps-alert>
  </ng-template>
</p-toast>
